export default __webpack_public_path__ + "static/delay-d4defbd96df266e9f76ba1ac8b884f93.png";